import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Register from "./Pages/RegisterFormPages/Register";
import Login from "./Pages/RegisterFormPages/Login";
import UserDashboard from "./Pages/UserDashboardPages/UserDashboard";
import PrivateRoute from "./Component/ProtectedRoute/PrivateRoute";
import AdminDashboard from "./Pages/AdminDashboardPages/AdminDashboard";
import AdminRoute from "./Component/ProtectedRoute/AdminRoute";
import Plane from "./Component/Layout/FooterIcon/Plane";
import PlanPurchase from "./Pages/UserDashboardPages/PlanPurchase";
import Teams from "./Pages/UserDashboardPages/Teams";
import Profile from "./Pages/UserDashboardPages/Profile";
import Ads from "./Pages/UserDashboardPages/Ads";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route path="user" element={<UserDashboard />} />
          <Route path="user/plans" element={<Plane />} />
          <Route path="user/plan/purchase" element={<PlanPurchase />} />
          <Route path="user/teams" element={<Teams />} />
          <Route path="user/profile" element={<Profile />} />
          <Route path="user/ads" element={<Ads />} />
        </Route>
        <Route path="/dashboard" element={<AdminRoute />}>
          <Route path="admin" element={<AdminDashboard />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
